export default __webpack_public_path__ + "static/media/km_driven.8b325883.svg";